module.exports = __webpack_public_path__ + "files/cfb5070460fed3898a1e244182f2f141.png";